/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import Header from "./header";
import Footer from "./footer";
import Listing from "./listing";
import { getJobs } from "../../services/jobs"; //

const JobList = () => {
  const [jobLists, setjobLists] = useState([]);
  const [loading, setLoader] = useState(true);

  useEffect(() => {
    const fetchJobs = async () => {
       setLoader(true);
      try {
        const response = await getJobs().then((res) => res.json());
        if (response) {
          setLoader(false);
          setjobLists(response);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoader(false);
      }
    };
    fetchJobs();
  }, []);

  return (
    <div>
      {/* Job Portal Website Stylesheet */}
      <div className="container-fluid bg-white p-0">
        {/* Spinner Start */}
        {/* <div id="spinner" className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <div className="spinner-border text-primary" style={{width: '3rem', height: '3rem'}} role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div> */}
        {/* Spinner End */}
        {/* Navbar Start */}
        <Header path="job_list"></Header>
        {/* Navbar End */}
        {/* Header End */}
        <div className="container-fluid py-5 bg-dark page-header mb-5">
          <div className="container my-5 pt-5 pb-4">
            <h1 className="display-3 text-white mb-3 animated slideInDown">
              Trending Jobs
            </h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb text-uppercase">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                {/* <li className="breadcrumb-item"><a href="#">Pages</a></li> */}
                <li
                  className="breadcrumb-item text-white active"
                  aria-current="page"
                >
                  Jobs
                </li>
              </ol>
            </nav>
          </div>
        </div>
        {/* Header End */}
        {/* Jobs Start */}
        <Listing jobs={jobLists}></Listing>
        {/* Jobs End */}
        {/* Footer Start */}
        <Footer></Footer>
        {/* Footer End */}
        {/* Back to Top */}
        <a
          href="#"
          className="btn btn-lg bg-primary btn-lg-square back-to-top text-white"
        >
          <i className="bi bi-arrow-up" />
        </a>
      </div>
      {/* JavaScript Libraries */}
      {/* Job Portal Website Javascript */}
    </div>
  );
};

export default JobList;
